import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './components/Home'
import Services from './components/Services'
import About from './components/About'
import Community from './components/Community'
import ContactForm from './components/ContactForm'
import PrivacyPolicy from './components/PrivacyPolicy'
import Marketing from './components/Marketing'
import SocialMedia from './components/marketing/SocialMedia'
import AppDevelopment from './components/services/AppDevelopment'
import SoftwareTesting from './components/services/SoftwareTesting'
import TechnicalResourcing from './components/services/TechnicalResourcing'
import DevOpsCICD from './components/services/DevOpsCICD'
import WebDevelopment from './components/services/WebDevelopment'
import MobileDevelopment from './components/services/MobileDevelopment'
import CaseStudies from './components/case-studies/CaseStudies'
import MidnightCaseStudy from './components/case-studies/Midnight'
import OvoCaseStudy from './components/case-studies/OVO'
import GsgCaseStudy from './components/case-studies/GSG'
import PumaCaseStudy from './components/case-studies/Puma'
import VegaCaseStudy from './components/case-studies/Vega'
import DaznCaseStudy from './components/case-studies/DAZN'
import InstantOfficesCaseStudy from './components/case-studies/InstantOffices'
import ScrollToTop from './components/ScrollToTop'
import AnalyticsTracker from './components/AnalyticsTracker'
import './styles/App.css'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AnalyticsTracker />
      <div className="App">
        <Header />
        <main className="main-content body">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/app-development" element={<AppDevelopment />} />
            <Route path="/services/software-testing" element={<SoftwareTesting />} />
            <Route path="/services/technical-resourcing" element={<TechnicalResourcing />} />
            <Route path="/services/devops-cicd" element={<DevOpsCICD />} />
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/services/mobile-development" element={<MobileDevelopment />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/midnight" element={<MidnightCaseStudy />} />
            <Route path="/case-studies/ovo" element={<OvoCaseStudy />} />
            <Route path="/case-studies/global-savings-group" element={<GsgCaseStudy />} />
            <Route path="/case-studies/puma" element={<PumaCaseStudy />} />
            <Route path="/case-studies/vega" element={<VegaCaseStudy />} />
            <Route path="/case-studies/dazn" element={<DaznCaseStudy />} />
            <Route path="/case-studies/instant-offices" element={<InstantOfficesCaseStudy />} />
            <Route path="/about" element={<About />} />
            <Route path="/community" element={<Community />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/marketing/social-media" element={<SocialMedia />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
